let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jfnqE")).then(() => parcelRequire('bwXPC'));